import { create } from 'zustand';
import dayjs from 'dayjs';

const useMovementStore = create((set) => ({
  // Main movement object
  movement: {
    date: dayjs(),
    origin_deposit: null,
    destination_deposit: null,
    movement_point: null,
    items: [],
    user: null, // Will be set by the backend
  },

  // Current movement item being edited
  movementItem: {
    product: null,
    quantity: "",
    selected_unit: "",
  },

  // Update the movement object with new values
  updateMovement: (values) => 
    set((state) => ({
      movement: { ...state.movement, ...values },
    })),

  // Set current movement item
  setMovementItem: (values) => 
    set((state) => ({
      movementItem: { ...state.movementItem, ...values },
    })),

  // Add item to the movement
  addItem: (item) =>
    set((state) => ({
      movement: {
        ...state.movement,
        items: [...state.movement.items, item],
      },
    })),

  // Remove item from the movement
  removeItem: (index) =>
    set((state) => ({
      movement: {
        ...state.movement,
        items: state.movement.items.filter((_, i) => i !== index),
      },
    })),

  // Reset the entire movement
  resetMovement: () =>
    set({
      movement: {
        date: dayjs(),
        origin_deposit: null,
        destination_deposit: null,
        movement_point: null,
        items: [],
        user: null,
      },
    }),

  // Reset just the current movement item
  resetMovementItem: () =>
    set({
      movementItem: {
        product: null,
        quantity: "",
        selected_unit: "",
      },
    }),
}));

export default useMovementStore; 